/* eslint-disable no-console */
import { Analysis } from 'common-spectrum';
export function fromSIV(content) {
    const analysis = new Analysis();
    const allLines = content.split(/[\r\n]+/);
    const sampleMeta = parseS(allLines.filter((line) => /X S_/.exec(line)));
    const instrumentMeta = parseV(allLines.filter((line) => /X V_/.exec(line)));
    const date = parseDate(allLines.filter((line) => /X d_t/.exec(line))[0]);
    const parts = content.split('WAVES\t');
    for (const part of parts) {
        const lines = part.split(/[\r\n]+/);
        const ys = lines
            .filter((line) => /^[\t 0-9.eE-]+$/.exec(line))
            .map((line) => Number(line));
        if (ys.length < 10)
            continue;
        const kind = lines[0].trim();
        const metaLines = lines
            .filter((line) => /^X /.exec(line))
            .map((line) => line.substring(2));
        const axis = parseScale(metaLines[0], ys.length);
        if (axis.x === undefined) {
            console.log('Unknown X axis:', axis.kind, axis.unit);
            continue;
        }
        if (axis.y === undefined || axis.y.unit !== 'A') {
            console.log('Unknown Y axis:', axis.kind, axis.unit);
            continue;
        }
        // const note = parseNote(metaLines[1]);
        const xs = axis.x.values;
        const data = {
            x: xs,
            y: ys,
        };
        const meta = {
            ...sampleMeta,
            date,
            experiment: kind,
            ...instrumentMeta,
        };
        analysis.pushSpectrum({
            x: {
                type: 'independent',
                label: axis.x.kind,
                unit: axis.x.unit,
                data: data.x,
            },
            y: {
                type: 'dependent',
                label: axis.y.kind,
                unit: axis.y.unit,
                data: data.y,
            },
        }, { dataType: 'IV spectrum', title: '', meta });
    }
    return analysis;
}
function parseDate(line) {
    const dateString = line.replace('X d_t=', '').trim().replace(/"/g, '');
    return new Date(dateString);
}
function parseScale(line, nbValues) {
    let result = {};
    const parts = line.replace(/ ([xy]) /g, ',$1,').split('; ');
    for (const part of parts) {
        const parsedPart = parseScalePart(part, nbValues);
        result[parsedPart.axis] = parsedPart;
    }
    return result;
}
function parseS(lines) {
    let result = {};
    for (const line of lines) {
        const key = getFieldName(line.replace(/X ._([^=]*)=(.*)/, '$1').trim());
        let value = line
            .replace(/X ._([^=]*)=(.*)/, '$2')
            .trim()
            .replace(/^"(.*)"$/, '$1');
        if (!isNaN(Number(value)))
            value = Number(value);
        result[key] = value;
    }
    return result;
}
function parseV(lines) {
    let result = {};
    for (const line of lines) {
        const key = getFieldName(line.replace(/X ._([^=]*)=(.*)/, '$1').trim());
        let value = line
            .replace(/X ._([^=]*)=(.*)/, '$2')
            .trim()
            .replace(/^"(.*)"$/, '$1');
        if (!isNaN(Number(value)))
            value = Number(value);
        result[key] = value;
    }
    return result;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function parseNote(line) {
    line = line.replace(/"/g, '').replace(/\\r/g, ';');
    const parts = line.split(/ *[;,] */);
    let result = {};
    for (const part of parts) {
        const semiColumn = part.indexOf(':');
        const key = getFieldName(part.substring(0, semiColumn));
        let value = part
            .substring(semiColumn + 1)
            .trim()
            .replace(/^"(.*)"$/, '$1');
        if (!isNaN(Number(value)))
            value = Number(value);
        if (!key)
            continue;
        result[key] = value;
    }
}
function parseScalePart(scale, nbValues) {
    const parts = scale.split(',');
    let result = {
        axis: parts[1],
        kind: parts[0],
        unit: parts[4].replace(/"/g, ''),
    };
    if (result.kind === 'SetScale/P') {
        let from = Number(parts[2]);
        const step = Number(parts[3]);
        const values = [];
        for (let i = 0; i < nbValues; i++) {
            values.push(from);
            from += step;
        }
        result.values = values;
    }
    return result;
}
function getFieldName(key) {
    const mapping = {
        CE: 'counterElectrodeType',
        Calibrationfile: 'calibrationFile',
        Username: 'username',
        WE: 'workingElectrodeGlass',
        cellname: 'cellname',
        electrolyte: 'electrolyteZ960',
        layer: 'semicondutorLayer',
        specification: 'remarks',
        temp: 'workingTemperature',
        type: 'typeOfCell',
        AR: 'cellActiveArea',
        IT: 'powerIn',
    };
    if (key in mapping)
        return mapping[key];
    return key;
}
//# sourceMappingURL=data:application/json;base64,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